import React from 'react';
import { useEffect, useState } from 'react';

import {Photos} from './photos';
import { ExportChartData } from './export.js';

import { Tabs, Row, Col, Space, Button, Dropdown, Select, Menu, Switch } from 'antd';
import { CustomDatepicker } from '../datepicker/custom.datepicker.js';
import { FileExcelOutlined, ReloadOutlined, DownOutlined, CopyOutlined, InfoCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons';

import Draggable from 'react-draggable';
import { Resizable } from 'react-resizable';
import '../../../node_modules/react-resizable/css/styles.css';

import dayjs from 'dayjs';

import References from '../../helpers/Reference';
import { loadMeasurers, loadPhotos, parsePhotos, getChartType, findInJSONArray, objectValue, objectKey, CopyText, ShowLocaleDateTime, prepareMeasurers, loadGroupMeasurers, prepareGroupMeasurers, findIndexInJSONArray } from '../../helpers/helpers';
import {AnalyticChartChange} from './components/analytic.radio-groups.js';

import Chart from "chart.js/auto";
import { Line, Bar, PolarArea } from 'react-chartjs-2';
import annotationPlugin from 'chartjs-plugin-annotation';
import { CategoryScale } from "chart.js";

import 'chartjs-adapter-moment';
import { chartBarOptions, chartPolarOptions } from '../../helpers/chartoptions';
import { forecastPics, polarChartPrepareData, round } from '../../helpers/helpers';

import { Events } from '../Event/events.component.js';
import { Analytic } from './analytic.js';

import { useAuth } from '../Auth/store.js';
import { CorrrectGroupToMch, FindFirstMchInGroup, getChartDatasets, getGroupChartData, setChartMax, setChartMin, setLineChartOptions, SetMchGroups } from './utils.js';
import { ChartTabs } from './ChartTabs.js';
import { MchsDropdown } from './mchs.dropdown.js';
import { ChartWindowHelpContext } from './components/help-context.js';
import { AnalyticHelpContext } from './components/help-context-analytic.js';
import { EventHelpContext } from './components/help-context-events.js';
import { WindroseHelpContext } from './components/help-context-windrose.js';
import { ForecastAggHelpContext } from './components/help-context-forecast-agg.js';
import { PhotoGallery } from '../PhotoGallery/photo.gallery.js';

dayjs.locale('ru');
Chart.register(CategoryScale);
Chart.register(annotationPlugin);

const normalizedOptions = () => {
    return Object.keys(References.normalizes_methods).map( key => {
        return {
            label: References.normalizes_methods[key],
            value: key
        }
    })
}

export const ChartWindow = ({station, mchs, onClose}) => {    
    const type = 'mchs';
    const DRAGGABLE_BOUNDS_PERCENT = 0.15;

    const now = station?.finish ? new Date(station.finish) : new Date().getTime() + 1000 * 3600 * 2;
    const prev = station?.start ? new Date(station.start) : now - 1000 * 60 * 60 * 24;
    const prev3days = now - 1000 * 60 * 60 * 24 * 3;
    const stationInfo = station.station;

    const [ loaded, setLoaded ] = useState( false );
    const [ prepared, setPrepared ] = useState( false );
    const [ expired, setExpired ] = useState( false );

    const [ activeTab, setActiveTab ] = useState('mchs');
    const [ measurer, setMeasurer ] = useState({});

    const [ chartType, setChartType] = useState( null );
    const [ chartData, setChartData ] = useState({});
    const [ isChartRedraw, setIsChartRedraw ] = useState( false );
    const [ chartSettings, setChartSettings] = useState({});
    const [ chartKind, setChartKind] = useState('chart');
    const [ chartTabActive, setChartTabActive ] = useState(0);

    //настройки для сгрппуированных каналов
    const [ isChartGrouped, setIsChartgrouped ] = useState( false );
    const [ measurerGroups, setMeasurerGroups ] = useState([]);
    const [ measurersHiddenInGroup, setMeasurersHiddenInGroup ] = useState([]);

    //закладка для разных типов графика для одного ИК (ветер: роза ветров и линейный график, две вкладки)
    const [ chartForciblyType, setChartForciblyType] = useState();

    const [ start, setStart ] = useState( new Date(prev).toLocaleString(References.locale) );
    const [ finish, setFinish ] = useState( new Date(now).toLocaleString(References.locale) );

    const [ loadedPhoto, setLoadedPhoto ] = useState( false );
    const [ expiredPhoto, setExpiredPhoto ] = useState( false );
    const [ photos, setPhotos ] = useState([]);
    const [ lastPhoto, setLastPhoto ] = useState([]);
    const [ startPhoto, setStartPhoto ] = useState( new Date(prev3days).toLocaleString(References.locale) );
    const [ finishPhoto, setFinishPhoto ] = useState( new Date(now).toLocaleString(References.locale) );

    const [ settings, setSettings ] = useState({});
    const [ isShowSettings, setIsShowSettings ] = useState( false );    
    const [ isShowedSettings, setIsShowedSettings ] = useState( false );

    const [ isShowAnalytic, setIsShowAnalytic ] = useState( false );

    const [ windowSize, setWindowSize ] = useState({
        'width': 500,
        'height': document.documentElement.clientHeight * 0.9
    });

    const [ isShowExportData, setIsShowExportData ] = useState( false );
    const [ isMchsDropDownOpened, setIsMchsDropDownOpened] = useState( false );

    const [ normalizeMethod, setNormalizeMethod ] = useState(null);

    const [ isShowHelpContext, setIsShowHelpContext ] = useState(false);
    const [ isShowAnalyticHelpContext, setIsShowAnalyticHelpContext ] = useState(false);
    const [ isShowEventHelpContext, setIsShowEventHelpContext ] = useState(false);
    const [ isShowWindroseHelpContext, setIsShowWindroseHelpContext ] = useState(false);
    const [ isShowForecastAggHelpContext, setIsShowForecastAggHelpContext] = useState(false)

    const [ startPhotoInGallery, setStartPhotoInGallery ] = useState( 0 );
    const [ isShowPhotoGallery, setIsShowPhotoGallery ] = useState( false );

    const {permission} = useAuth();

    useEffect(() => {
        if (!loaded) {
            const isOpenByGroup = stationInfo?.mchs_groups?.hasOwnProperty(mchs);
            const isOpenByPhoto = stationInfo?.photo?.uuid === mchs;

            //если открываем окно из фото, то загружаем первый измерительный канал из списка
            if (isOpenByPhoto)
                mchs = stationInfo?.mchs[0].uuid;

            let currMch = null;
            if (isOpenByGroup) {
                currMch = FindFirstMchInGroup(stationInfo.mchs, mchs);
                initByGroup(currMch)
            } else {
                currMch = findInJSONArray(stationInfo.mchs, 'uuid', mchs);                
                initByMch(currMch);
            }
            setMeasurer( currMch );
        }

    }, []);

    const initByGroup = (mch) => {
        onMchsGroupLoading(station.station, mch);
    }

    const initByMch = (mch) => {
        setSettings(mch.settings);
        setIsShowSettings(mch.settings != null);
        setIsShowAnalytic( References.mchs[mch.type]?.analytic )

        //измертиельный канал
        loadMeasurers(mch.uuid, type, mch.type, start, finish, null, normalizeMethod)
        .then((data) => {
            const chartType = getChartType( mch.chartType )
            const chartData = prepareMeasurers(data, mch.uuid, type, mch.type, chartType, null, mch.settings)
                                                    
            setChartData( chartData );
            setChartType( chartType ); 
            if (station.tab)
                onTabChange( station.tab );

            setLoaded(true);
            setPrepared(true);
        });   

    }

    const ShowSettings = (  ) => {
        let hasSettings = 0;
        let result = null;
        if (References.mchs[measurer.type].hasOwnProperty('settings')) {
            result = (Object.keys(References.mchs[measurer.type].settings).map((val) => {
                
                if (settings[val]) {                    
                    ++hasSettings;

                    const settingInfo = References.mchs[measurer.type].settings[val];
                    const unit = settingInfo?.unit ? settingInfo.unit : References.mchs[measurer.type].unit;
                    const prec = settingInfo?.prec ? settingInfo.prec : References.mchs[measurer.type].precision;

                    return (
                        <div className="d-flex jc-space-between" key={"settings" + measurer.uuid + val}>
                            <div className="mr-2">{References.mchs[measurer.type].settings[val].name}</div>
                            <div className="ml-2 b">{round(settings[val], prec)} {unit}</div>
                        </div>
                    );
                }
            }));
        }
        if (!hasSettings)
            result = <div>{References.dictionary.no_canal_settings}</div>;
        return result;
    }

    const onNormalizeChange = ( value ) => {
        setNormalizeMethod(  value );
        setExpired( true );
    } 

    const onMeasurerSettingsClick = (e) => {
        let currisShowedSettings = isShowedSettings;
        setIsShowedSettings( !currisShowedSettings );
        e.stopPropagation();

        window.addEventListener("click", onMeasurerSettingsClose);
    }    

    const onMeasurerSettingsClose = () => {
        window.removeEventListener("click", onMeasurerSettingsClose);        
        setIsShowedSettings( false );
    }

    const onMeasurerExportDataClick = () => {
        let currIsShowedExportData = isShowExportData;
        setIsShowExportData( !currIsShowedExportData );
    }

    const onChartKindChange = ( e ) => {
        const kind = e.target.value;
        setChartKind( kind );
    }

    const handlerClose = (e) => {
        onClose( station.index );
    }

    const onStartOk = ( value ) => {
        setStart( new Date(value.$y, value.$M, value.$D, value.$H).toLocaleString(References.locale))
        setExpired( true );
    }

    const onFinishOk = ( value ) => {
        setFinish( new Date(value.$y, value.$M, value.$D, value.$H).toLocaleString(References.locale))
        setExpired( true );        
    }

    const onStartPhotoOk = ( value ) => {
        setStartPhoto( new Date(value.$y, value.$M, value.$D, value.$H).toLocaleString(References.locale))
        setExpiredPhoto( true );
    }

    const onFinishPhotoOk = ( value ) => {
        setFinishPhoto( new Date(value.$y, value.$M, value.$D, value.$H).toLocaleString(References.locale))
        setExpiredPhoto( true );        
    }

    const onMchLoading = () => {
        setLoaded(false);
        loadMeasurers( measurer.uuid, type, measurer.type, start, finish, chartSettings, normalizeMethod )
            .then((data) => {

                const chartType = chartForciblyType ? chartForciblyType : getChartType( measurer.chartType );                
                const chartData = prepareMeasurers(data, measurer.uuid, type, measurer.type, chartType, chartSettings, settings);                
                setChartType( chartType );                                
                setChartData(chartData);
                setLoaded(true);
                setExpired( false );
        });
    }

    const onShowChartClick = () => {
        if (isChartGrouped)
            onMchsGroupLoading(station.station, measurer);
        else
            onMchLoading();
    }
    
    const setBarChartOptions = () => {
        let chartOptions = chartBarOptions();

        //устанавливаем min-max для оси y
        chartOptions.scales.y.min = setChartMin(chartData, measurer);
        chartOptions.scales.y.max = setChartMax(chartData, measurer);        

        //дополняем тултипы
        if (measurer.tooltips) {
            switch (measurer.type) {
                case 'precipitationduo':
                case 'precipitation':                
                    chartOptions.plugins.tooltip.callbacks = {
                        footer: function( item ) {  
                            if (item.length > 0) {                                                                 
                                let field = References.mchs[measurer.type].bar_colors.field;
                                let dataIndex = item[0].dataIndex;     

                                let precipitationType = chartData.source[dataIndex][field];
                                let precipitationValue = chartData.data[dataIndex];

                                if (precipitationValue > 0 && measurer.tooltips.hasOwnProperty(precipitationType))                                
                                    return measurer.tooltips[precipitationType];
                            }
                        }
                    }
                break;
            }
        }

        return chartOptions;

    }

    const precipitaionIcons = ( field ) => {
        let values      = [];
        let pics        = [];

        for ( let i in chartData.source ) {
            let me = chartData.source[i];
            let pic = new Image(25, 25);
            if ( chartData.data[i] > 0 && me.hasOwnProperty( field ) && forecastPics.hasOwnProperty(me[field]) ) {
                pic.src = 'data:image/svg+xml;utf8,' + forecastPics[me[field]];
            }
            pics.push(pic);
            values.push(chartData.data[i] + 0.2);
        }

        return {
            type: 'line',
            data: values,
            label: null,
            backgroundColor: "rgba(255, 255, 255, 1)",
            borderColor: "rgba(255, 255, 255, 1)",
            borderWidth: 0,
            hideTooltip: true,
            pointStyle: pics
        }
    }

    const chartPointIcons = ( params ) => {
        let icons = [];
        switch (params.function) {
            case 'precipitaionIcons':
                icons = precipitaionIcons( params.field );
                break;
        }
        return icons;
    }

    const chartDataIcons = () => {
        if (References.mchs[measurer.type].hasOwnProperty('point_icons')) {
            if (typeof References.mchs[measurer.type].point_icons != 'undefined') {
                return chartPointIcons(References.mchs[measurer.type].point_icons);
            }
        }
    }

    const chartDataBarColors = () => {
        let def =  "#00a";
        if (!References.mchs[measurer.type].hasOwnProperty('bar_colors')) 
            return def;

        let result = [];

        let me = References.mchs[measurer.type].bar_colors;
        let colors = me.colors;
        let field = me.field;
        let func = me.function;

        switch (func) {
            case 'precipitationColor':
                for (let i in chartData.source) {                    
                    let type = chartData.source[ i ][ field ];
                    if (colors.hasOwnProperty(type))
                        result.push( colors[type]);
                    else
                        result.push( def );
                }
                break;

            default:
                result.push( def );
            break;                
        }
        return result;            

    }

    const onMchsGroupLoading = (station, mch) => {
        setIsMchsDropDownOpened(false);        
        setLoaded( false );
        setIsChartgrouped(true);                
        setChartSettings({});  
        setMeasurersHiddenInGroup([]);

        mch = CorrrectGroupToMch(mch);        
        loadGroupMeasurers(station, mch.group_id, start, finish )
        .then(data => {
            setIsShowedSettings( false );  
            setIsShowSettings(false);

            setMeasurer(mch);            
            setChartData(prepareGroupMeasurers(data, mch.type, mch.settings ));            
            setMeasurerGroups(SetMchGroups(station?.mchs, mch.group_id));
        })
        .finally(_ => {
            setLoaded(true);
            setExpired( false );
            setPrepared(true);

        });        
    }

    const onMchsDropDownGroupChartClick = ( station, mch ) => {
        onMchsGroupLoading(station, mch);
    }

    const onMchsDropDownClick = ( mchs ) => {
        setIsChartgrouped(false);        
        setIsMchsDropDownOpened(false);
        setLoaded( false );
        setChartSettings({}); 
        setMeasurersHiddenInGroup([]);                

        loadMeasurers(mchs.uuid, type, mchs.type, start, finish)
            .then((data) => {
                const chartType = getChartType( mchs.chartType )

                setMeasurer( mchs );        
                setIsShowedSettings( false );       
                setSettings(mchs.settings);
                setIsShowSettings(mchs.settings != null);
                setChartForciblyType(null);
                setChartType( getChartType( mchs.chartType ) );                                                

                const chartData = prepareMeasurers(data, mchs.uuid, type, mchs.type, chartType, null, mchs.settings)

                setChartData(chartData);

                const isHasAnalytic = References.mchs[mchs.type]?.analytic        
                setIsShowAnalytic( isHasAnalytic );                
                if (!isHasAnalytic)
                    setChartKind('chart');
        
                setLoaded( true );
            });

    };

    const onMchsDropDownOpenChange = (nextOpen) => {
        setIsMchsDropDownOpened(nextOpen);
    }

    const onPhotoClick = () => {
        showPhotos();
    }

    const onPhotoLoad = (photoId, src) => {
        const index = findIndexInJSONArray(photos, 'id', photoId)
        if (index > -1) {
            const currPhotos = photos;
            currPhotos[index]['src'] = src;
            setPhotos([...currPhotos]);
        }
    }

    const onOpenPhotoGallery = ( idx ) => {
        setStartPhotoInGallery(idx)
        setIsShowPhotoGallery(true)
    }

    const onTabChange = ( key ) => {
        setActiveTab( key );
        if ( key == 'photo') {
            if (typeof stationInfo.photo != 'undefined')
                showPhotos( stationInfo, startPhoto, finishPhoto );
        }

    }

    const onTabChartTypeChange = ( key ) => {
        setChartType( key );
        setChartForciblyType( key );
    }

    const onTabChartChange = ( key ) => {
        setChartTabActive(key);
    }

    const onResizeStart = ( event ) => {
        setIsChartRedraw(false);
    }

    const onResize = (event, props) => {
        setWindowSize({
            "width": props.size.width,
            "height": props.size.height
        });
    }

    const onResizeStop = () => {
        setIsChartRedraw( true );
    }

    const onMchItemGroupVisibleChange = ( idx, state ) => {
        let hiddenMeasurers = measurersHiddenInGroup;
        if (!state) 
            hiddenMeasurers.push(idx);
        else
            hiddenMeasurers = hiddenMeasurers.filter(val => val !== idx)
        setMeasurersHiddenInGroup([...hiddenMeasurers]);
    }

    const onCloseHelpContext = () => {
        setIsShowHelpContext(false);
    }

    const onCloseAnalyticHelpContext = () => {
        setIsShowAnalyticHelpContext(false)
    }

    const onShowAnalyticHelpContext = () => {
        setIsShowAnalyticHelpContext(true);
    }

    const onCloseEventHelpContext = () => {
        setIsShowEventHelpContext(false);
    }

    const onShowEventHelpContext = () => {
        setIsShowEventHelpContext(true);
    }

    const onCloseWindroseHelpContext = () => {
        setIsShowWindroseHelpContext(false);
    }

    const onShowWindroseHelpContext = () => {
        setIsShowWindroseHelpContext(true);
    }

    const onCloseForecastAggHelpContext = () => {
        setIsShowForecastAggHelpContext(false);
    }

    const onShowForecastAggHelpContext = () => {
        setIsShowForecastAggHelpContext(true);
    }

    const showPhotos = () => {
        setActiveTab('photo')        
        setLoadedPhoto( false );
        loadPhotos( stationInfo.photo, startPhoto, finishPhoto )
        .then((data) => {
            let result = parsePhotos(data);
            setPhotos( result );
            setLastPhoto( result.length > 0 ? result[result.length - 1] : []);
            setLoadedPhoto( true );
            setExpiredPhoto( false );
        });
    }
    
    const setPrecipitationAggregation = ( key, value ) => {
        var settings = chartSettings;        

        if (key === 'period' && value.length === 0) {
            settings = {
                period: "",
                rolling: "",
                precipitation_type: "",
                alt_field: ""
            }
        }
        else { 
            settings[key] = value;
            if (key === 'period' && !settings?.rolling)
                settings.rolling = "1";                
            settings.alt_field = References.mchs.precipitation.aggregate_field;                        
        }

        setChartSettings(prevData => ({...prevData, 
            period: settings.period,
            rolling: settings.rolling,
            precipitation_type: settings.precipitation_type,
            alt_field: settings.alt_field
        }) );
        setExpired( true );        
    }
            
    const mchsDropdownRender = (station, mchs, measurer, height) => {
        return <MchsDropdown 
            station={station}
            mchs={mchs}
            group={measurer?.group_id} 
            height={height}
            onClickHandle={onMchsDropDownClick} 
            onGroupChartClickHandle={onMchsDropDownGroupChartClick}
        />
    };     
                
    return (
        <>

        {isShowHelpContext && 
        <ChartWindowHelpContext 
            onClose={onCloseHelpContext}
        />
        }

        {isShowAnalyticHelpContext && 
        <AnalyticHelpContext
            onClose={onCloseAnalyticHelpContext}
        />
        }

        {isShowEventHelpContext && 
            <EventHelpContext
                onClose={onCloseEventHelpContext}
            />
        }

        {isShowWindroseHelpContext &&
            <WindroseHelpContext 
                onClose={onCloseWindroseHelpContext}
            />
        }

        {isShowForecastAggHelpContext &&
            <ForecastAggHelpContext 
                onClose={onCloseForecastAggHelpContext}
        />
        }

        {isShowPhotoGallery &&
            <PhotoGallery 
                images={photos} 
                startIndex={startPhotoInGallery} 
                mch={stationInfo.photo.uuid} 
                onClose={() => setIsShowPhotoGallery(false)}
            />
        }

        <Draggable 
            cancel={".no-draggable, .react-resizable-handle"}
            bounds={{
                left: windowSize.width * DRAGGABLE_BOUNDS_PERCENT - windowSize.width,
                right: document.documentElement.clientWidth -  windowSize.width * DRAGGABLE_BOUNDS_PERCENT,
                top: windowSize.height * DRAGGABLE_BOUNDS_PERCENT - windowSize.height,
                bottom: document.documentElement.clientHeight - windowSize.height * DRAGGABLE_BOUNDS_PERCENT
            }}
        >
        <Resizable height={windowSize.height} width={windowSize.width} onResizeStart={onResizeStart} onResize={onResize} onResizeStop={onResizeStop}>
        <div className="chart-window" style={{"left": 10 * station.index, "top": 10 * station.index, "width": windowSize.width, "height": windowSize.height}}>
            <span className="close no-draggable" onClick={handlerClose}>&times;</span>
            <span className="chart-window-help-icon help-icon no-draggable" onClick={() => {setIsShowHelpContext(true)}}><QuestionCircleOutlined /></span>
            <div className="b p-1 text-left chart-window-title flex-shrink-0" level_code={stationInfo.state.level_code}>
                {stationInfo.name}
            </div>

            <Tabs
                className="ph-1 pt-1 no-draggable flex-shrink-0"
                defaultActiveKey={station.tab}
                type="card"
                tabBarStyle={{
                    marginBottom: "0px"
                }}
                onChange={onTabChange}
                items={
                    References.tabsChannels.map((val) => {  
                        if ( val.type !== 'photo' || station?.station?.photo?.uuid) 
                            return {
                                label: val.name,
                                key: val.type
                            }
                    })
                }
                />
            <div className={activeTab !==  'mchs' ? 'd-none' : 'flex-grow-1'}>
                <div className="measurers-wrap">   
                    {!loaded &&
                    <div className="loading loading-wrapper"></div>
                    }

                    {prepared &&
                    <>
                    <div className="white p-1 bordert-555 flex-shrink-0 pos-relative" level_code={measurer.level_code === null ? References.no_data_code : measurer.level_code}>
                        <div className="text-uppercase b">
                            <Dropdown
                                key="analytic_tab"
                                onOpenChange={onMchsDropDownOpenChange}
                                open={isMchsDropDownOpened}
                                trigger={['click']}
                                dropdownRender={() => mchsDropdownRender(stationInfo, stationInfo.mchs, measurer, windowSize.height)}
                            >
                                <a onClick={(e) => e.preventDefault()} className="w-100-child cursor-pointer no-draggable">
                                    <Space>
                                        {measurer.typeName}
                                        <DownOutlined />
                                    </Space>
                                </a>                                
                            </Dropdown>

                                <div key="chart_analytic_wrapper" className="chart_analytic_wrapper">
                                    <AnalyticChartChange isHasAnalytic={isShowAnalytic} onChartKindChange={onChartKindChange}/>
                                </div>                                    

                        </div>
                    </div>

                    {chartKind === 'chart' ? (
                    <>
                    <Row className="bg-color-eee borderb-555 flex-shrink-0">
                        <Col span="24">
                            <div className="p-1 d-flex jc-space-between pos-relative">
                                <div>
                                    <Space>
                                        <CustomDatepicker isCustom={false} start={start} finish={finish} onStart={onStartOk} onFinish={onFinishOk}/>                                    
                                        <Button type="default" shape="circle" icon={<ReloadOutlined />} onClick={onShowChartClick} className="no-draggable"/>                                                                        
                                    </Space>
                                </div>
                                <div className="text-nowrap">
                                    <Button type="default" shape="circle" icon={<FileExcelOutlined />} onClick={onMeasurerExportDataClick} className={"d-inline-block no-draggable ml-2"}/>                                                                                                    
                                    <Button type="default" shape="circle" icon={<InfoCircleOutlined />} onClick={onMeasurerSettingsClick} className={"no-draggable" + (!isShowSettings ? " d-none" : " ml-1 d-inline-block")}/>                                                                    
                                </div>
                                {isShowedSettings &&
                                    <div className="measurer-settings-panel">
                                        <div className="measurer-settings-close" onClick={onMeasurerSettingsClose}>×</div>
                                        {ShowSettings()}
                                    </div>
                                }
                            </div>
                        </Col>

                        { permission.permissions.can_view_tech_data && References.normalizes_channels.indexOf(measurer.type) !== -1 &&
                            <Col span={24} className="p-1">
                                <Select
                                    defaultValue={'no'}                                        
                                    style={{ width: '100%' }}
                                    options={normalizedOptions()}
                                    onChange={onNormalizeChange}
                                ></Select>
                            </Col>                                
                        }                                

                        {measurer.hasOwnProperty('type') && measurer.type.indexOf('precipitation') > -1 &&

                        <>
                        <Col span="24" className="pl-1 pr-1 mb-1">
                            <Row>
                                <Col span="8" className="pr-1">
                                    <Select 
                                        defaultValue=""
                                        value={chartSettings.period}
                                        style={{
                                            width: "100%"
                                        }}
                                        options={[
                                            {value: "", label: "10 минут"},
                                            {value: "1H", label: "1 час"},
                                            {value: "3H", label: "3 часа"}, 
                                            {value: "12H", label: "12 часов"}
                                        ]}
                                        onChange={(value) => setPrecipitationAggregation('period', value)}
                                        placeholder={`Период агрегации`}
                                    />
                                </Col>
                                <Col span="8">                                    
                                    <Select 
                                        defaultValue="1"
                                        value={chartSettings.rolling || "1"}
                                        style={{
                                            width: "100%"
                                        }}
                                        options={[
                                            {value: "1", label: 'Скользящие'},
                                            {value: "0", label: 'Дискретные'}
                                        ]}
                                        onChange={(value) => setPrecipitationAggregation('rolling', value)}
                                        placeholder={`Тип агрегации`}
                                        disabled={!chartSettings?.period}                                        
                                    />
                                </Col>
                                <Col span="8" className="pl-1">
                                    <Select 
                                        defaultValue=""
                                        value={chartSettings.precipitation_type}
                                        style={{
                                            width: "100%"
                                        }}
                                        options={[
                                            {value: "", label: "Все осадки"},
                                            {value: "liquid", label: "Жидкие"},
                                            {value: "solid", label: "Твердые"}
                                        ]}
                                        onChange={(value) => setPrecipitationAggregation('precipitation_type', value)}                                        
                                        placeholder={`Тип осадков`}
                                        disabled={!chartSettings?.period}
                                    />
                                </Col>
                            </Row>
                        </Col>
                        </>
                        }                            

                        <Col span="24">
                            {typeof measurer.chartType == 'object' &&                        
                            <Tabs
                                className="ph-1 pt-1 no-draggable"
                                defaultActiveKey={0}
                                type="card"
                                tabBarStyle={{
                                    marginBottom: "0px"
                                }}
                                onChange={onTabChartTypeChange}
                                items={
                                    measurer.chartType.map(val => {
                                        return {
                                            label: objectValue(val),
                                            key: objectKey(val)
                                        }
                                    })
                                }
                                />
                                }


                            {typeof measurer.tabs == 'object' &&                        
                            <Tabs
                                className="ph-1 pt-1 no-draggable"
                                defaultActiveKey={chartTabActive}
                                type="card"
                                tabBarStyle={{
                                    marginBottom: "0px"
                                }}
                                onChange={onTabChartChange}
                                items={
                                    measurer.tabs.map((val, idx) => {
                                        return {
                                            label: val.title,
                                            key: idx
                                        }
                                    })
                                }
                                />
                                }


                        </Col>
                    </Row>

                    <div className={`pos-relative chart-detail-window flex-grow-1 ${expired ? 'bg-color-eee' : ''}`} style={{display: "flex", flexDirection: "row"}}>                                
                        <div className="chart-canvas">

                            {measurer.type === 'precipitationduo' && 
                            <span className="help-icon-chart" onClick={onShowForecastAggHelpContext}><QuestionCircleOutlined /></span> 
                            }

                            {expired && 
                                <div className="expired-wrapper"></div>
                            }

                            {chartType === 'bar' &&
                            <Bar
                                data={
                                    {labels: chartData.labels,
                                    datasets: [
                                        {
                                            fill: false,
                                            pointRadius: 0,
                                            backgroundColor: chartDataBarColors(),                                          
                                            borderColor: '#fff',
                                            borderSkipped: 'right',
                                            borderWidth: 1,
                                            spanGaps: false,
                                            barPercentage: 1,
                                            categoryPercentage: 1,                                    
                                            data: chartData.data,

                                        }
                                    ]
                                }}
                                options={setBarChartOptions()}
                                redraw={isChartRedraw}
                            />
                            }

                            {chartType === 'polar' &&
                            <div className="polar-chart-canvas">
                                {References.mchs[measurer.type].polar.show_limits &&
                                    <div>
                                        <div className="polar_limits mb-2">
                                        {References.mchs[measurer.type].polar.limits.map((limit, i) => 
                                            <div key={"limit" + i} className="polar_limits_item" style={{borderBottomColor: References.mchs[measurer.type].polar.limits_colors[i]}}>
                                                {limit}
                                            </div>
                                        )}                                                           
                                        <div className="polar_limits_item_unit ml-1">{References.mchs[measurer.type].unit}</div>
                                        </div>
                                    </div>
                                }
                                <div className="text-center flex-grow-1"> 
                                    <span className="help-icon-chart" onClick={onShowWindroseHelpContext}><QuestionCircleOutlined /></span> 
                                    <PolarArea
                                        data={
                                            {labels: References.mchs[measurer.type].polar.polar_labels,
                                            datasets: polarChartPrepareData(chartData.data, chartData.source, References.mchs[measurer.type].polar, References.mchs[measurer.type].unit)
                                        }}
                                        options = {chartPolarOptions}
                                        redraw={isChartRedraw}
                                    />  
                                </div>
                            </div>                  
                            }

                            {chartType === 'chart_tab' &&
                                <ChartTabs 
                                    measurer={measurer}
                                    data={chartData} 
                                    tabs={measurer.tabs} 
                                    tab={chartTabActive} 
                                    isChartRedraw={isChartRedraw}
                                />
                            }

                            {( (chartType == null) || (chartType === 'line')) &&
                            <Line
                                key={`${measurer.uuid}${isChartGrouped ? `-${measurer.group_id}` : null}`}
                                data={
                                    {labels: chartData.length > 1 ? chartData[0].labels : chartData.labels,
                                    datasets: chartData.length > 1 ? getGroupChartData( chartData, measurersHiddenInGroup ) : getChartDatasets( chartData, measurer )
                                }}
                                options={setLineChartOptions(measurer, chartData)}
                                redraw={isChartRedraw}
                                />

                            }
                        </div>                        

                        {isChartGrouped &&                             
                        <div className="text-center mv-auto ml-2 mr-2">
                            {measurerGroups.map((val, idx) => {
                                return (
                                    <div 
                                        key={`measurer-group-filter-${val.uuid}`}
                                        className="pt-1 b"
                                    >
                                        <Switch 
                                            className={`custom-switch custom-switch-bg-${idx}`}
                                            onClick={(checked, e) => onMchItemGroupVisibleChange(idx, checked, e)}
                                            checkedChildren={val.mch_name} 
                                            unCheckedChildren={val.mch_name} 
                                            defaultChecked
                                        />
                                    </div>
                                )
                            })}
                        </div>    
                        }

                    </div>
                    </>
                    ) : (
                        <>                            
                            <Analytic station={station} measurer={measurer} setLoaded={setLoaded} onHelpContextClick={onShowAnalyticHelpContext}/>
                        </>
                    )}

                    <div className="chart-window-footer bg-color-eee p-1 bordert-555 flex-shrink-0">
                        {!isChartGrouped && 
                        <div className="text-left">
                            Последнее измерение: 
                            <span className="b ml-1">{measurer.value}</span> {measurer.unit} {measurer.extInfo}
                            <span className="b ml-2">{
                            ShowLocaleDateTime(new Date(measurer.state_time))               
                            }</span>                    
                        </div>
                        }
                    </div>
                    </>
                    }
                </div>
            </div>

            <div className={activeTab !==  'event' ? 'd-none' : 'flex-grow-1'}>
                <div className="p-1">
                    {activeTab === 'event' &&
                        <Events station={station} container_height={windowSize.height} onHelpContextClick={onShowEventHelpContext}/>
                    }
                </div>
            </div>

            <div className={activeTab !== 'photo' ? 'd-none' : 'flex-grow-1'}>
                <div className="measurers-wrap">
                    {!loadedPhoto &&
                            <div className="loading loading-wrapper"></div>
                    }
                    <div className="p-1 bg-color-eee borderb-555 flex-shrink-0">
                        <Space>
                            <CustomDatepicker isCustom={false} start={startPhoto} finish={finishPhoto} onStart={onStartPhotoOk} onFinish={onFinishPhotoOk}/>
                            <Button type="default" shape="circle" icon={<ReloadOutlined />} onClick={onPhotoClick} className="no-draggable"/>                                    
                        </Space>
                    </div>

                    <div 
                        className={`chart-window-photo-items pos-relative ph-2 mt-2 flex-grow-1 of-y-auto no-draggable ${expiredPhoto ? 'bg-color-eee' : ''}`}
                        style={{height: 1}}
                    >
                        {expired && 
                            <div className="expired-wrapper"></div>
                        }
                        {photos.map( (data, idx) => 
                            <Photos key={"photo-" + data.id} measurerUUID={stationInfo.photo.uuid} photo={data} onLoad={onPhotoLoad} onClick={() => onOpenPhotoGallery(idx)}/>
                        )}
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    {lastPhoto.time &&
                    <div className="mt-1 bg-color-eee p-1 bordert-555 flex-shrink-0">
                            <div className="text-left">
                                Последнее фото: 
                                <span className="b ml-1">{
                                ShowLocaleDateTime(new Date(lastPhoto.time))               
                                }</span>                    
                            </div>
                    </div>
                    }
                </div>

            </div>            

            <div className={activeTab !== 'description' ? 'd-none' : 'flex-grow-1 of-y-auto'}>
                <div className="ph-2">
                    <Row>
                        <Col span="24">
                            <div className="b">
                                <Space>
                                    Координаты
                                    <Button type="default" shape="circle" icon={<CopyOutlined />} onClick={(e) => CopyText(stationInfo.lat +' '+stationInfo.lon)} className="no-draggable"/>
                                </Space>
                            </div>
                            <div className="ml-2">
                                <span className="rem">Широта/долгота</span><span className="ml-2">{stationInfo.lat}&nbsp;&nbsp;&nbsp;{stationInfo.lon}</span>
                            </div>
                        </Col>
                        <Col span="24">
                            <div className="mt-2 b">Положение</div>                                
                            <div className="ml-2 mt-1">
                                {stationInfo.area}
                                {stationInfo.district && `, ${stationInfo.district}`}
                                {stationInfo.city && `, ${stationInfo.city}`}
                                {stationInfo.locality && `, ${stationInfo.locality}`}
                                {stationInfo.monitoring_object && `, ${stationInfo.monitoring_object}`}
                            </div>
                        </Col>                            

                        <Col span="24">
                            <div className="mt-2 b">Закреплен за</div>                                
                            <div className="ml-2 mt-1">
                                {stationInfo.holder_name}
                            </div>
                        </Col>                            

                        
                    </Row>
                </div>
            </div>
        </div>
    </Resizable>
    </Draggable>

    {isShowExportData && 
        <ExportChartData start={start} finish={finish} station={station.station} measurer={measurer} normalizeMethod={normalizeMethod} settings={chartSettings} onClose={onMeasurerExportDataClick}/>
    }
    </>
     );
}
